import { useCallback } from 'react';
import { cn, Button, Gallery } from '@divlab/divanui';
import { IconChevronRight } from '@divlab/divanui/icons';

import * as ModalWindows from '@Stores/ModalWindows';
import useTranslation from '@Queries/useTranslation';
import ProductCard from './elements/ProductCard';
import styles from './RelatedProducts.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { ProductData } from '@Types/Product';

interface ProductsInInteriorProps extends HTMLAttributes<HTMLDivElement> {
  mainId: number;
  relatedProducts: ProductData[];
}

const defaultTitle = 'Сопутствующие товары карточка товара';

const RelatedProducts: FC<ProductsInInteriorProps> = (props) => {
  const { className, relatedProducts, mainId, ...restProps } = props;
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    ModalWindows.open('RelatedProductsEasyBuy', {
      mainId,
      analyticsTitle: defaultTitle,
    });
  }, [mainId]);

  return (
    <div {...restProps} className={cn(styles.wrapper, className)} data-testid='related'>
      <div className={styles.header}>
        <div className={styles.title}>{t('related-title')}</div>
        <Button
          data-testid='show-all'
          className={cn(styles.button, { [styles.showAll]: true })}
          view='rounded'
          theme='secondary'
          onClick={handleClick}
        >
          {t('show-more')}
          <IconChevronRight className={styles.iconChevronRight} />
        </Button>
      </div>
      <div className={styles.list}>
        <Gallery
          className={styles.gallery}
          cnSlide={styles.slide}
          cnScrollbar={styles.cnScrollbar}
          spaceBetween={15}
          scrollbar
        >
          {relatedProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </Gallery>
      </div>
    </div>
  );
};

export default RelatedProducts;
